export const ttlockConfig = {
  credentials: {
    title: "Configuración de TTLock",
    subtitle: "Ingresa tus credenciales de usuario TTLock",
    savedBadge: "Credenciales guardadas",
    noneBadge: "Sin credenciales",
    emailLabel: "Email de tu cuenta TTLock",
    emailPlaceholder: "tu-email@ejemplo.com",
    emailHelp: "El email que usas para iniciar sesión en TTLock",
    passwordLabel: "Contraseña",
    passwordPlaceholderSaved: "•••••••• (ya guardada, opcional cambiar)",
    passwordPlaceholder: "Tu contraseña de TTLock",
    passwordHelpSaved: "Puedes dejarla vacía si ya tienes una guardada.",
    passwordHelp: "La contraseña de tu cuenta TTLock.",
    testing: "Probando...",
    testConnection: "Probar Conexión",
    saving: "Guardando...",
    saveCredentials: "Guardar credenciales",
  },
  selector: {
    title: "Selector de cerraduras para esta propiedad",
    subtitleBefore: "Selecciona solo las cerraduras que aplican a ",
    subtitleStrong: "esta propiedad",
    subtitleAfter: ".",
    selectedCount: "{count} seleccionada | {count} seleccionadas",
    hintBefore: "Ingresa tus credenciales y pulsa ",
    hintStrong: "Probar Conexión",
    hintAfter: " para cargar tus cerraduras.",
    noneFound: "No se encontraron cerraduras. Revisa tu cuenta TTLock.",
    placeholder: "Selecciona cerraduras…",
    summaryCount: "{count} cerradura seleccionada | {count} cerraduras seleccionadas",
    emptySelection: "Ninguna cerradura seleccionada",
    saving: "Guardando...",
    save: "Guardar cerraduras de esta propiedad",
  },
  gateway: {
    with: "Con Gateway",
    without: "Sin Gateway",
  },
  pms: {
    title: "Control y asignación (PMS)",
    subtitleP1: "Asigna cada cerradura a ",
    subtitleStrongMain: "Puerta principal",
    subtitleP2: " o ",
    subtitleStrongUnit: "Unidad",
    subtitleP3: ".",
    assignedCount: "{count} asignada | {count} asignadas",
    empty: "Aún no tienes cerraduras guardadas para esta propiedad.",
    assignmentLabel: "Asignación",
    assignmentNone: "Sin asignar",
    assignmentCommon: "Puerta principal (común)",
    assignmentUnit: "Puerta de apartamento",
    hintNone: "No se controlará desde PMS.",
    hintAssigned: "Quedará asociada a esta propiedad para control/PINs.",
    unitLabel: "Unidad / Alojamiento",
    unitSelectPlaceholder: "Selecciona una unidad",
    unitHint: "Selecciona qué unidad abre esta cerradura.",
    nameLabel: "Nombre (opcional)",
    namePlaceholder: "Ej: Puerta principal / Apt 101",
    saving: "Guardando...",
    save: "Guardar asignación",
  },
  actions: {
    lock: "Bloquear",
    unlock: "Desbloquear",
    requiresGateway: "Requiere Gateway",
    createPasscode: "Crear Passcode",
    passcodeHistory: "Historial de Passcodes",
    refreshStatus: "Actualizar estado",
  },
  lockFallbackName: "Cerradura {id}",
  unitFallbackName: "Unidad {id}",
  history: {
    title: "Historial de Passcodes",
    revocationTitle: "Sobre la revocación de códigos:",
    withGatewayLabel: "Con gateway:",
    withGatewayText: "El código se revoca inmediatamente en la cerradura física.",
    withoutGatewayLabel: "Sin gateway:",
    withoutGatewayText:
      "El código se elimina del servidor TTLock, pero seguirá funcionando en la cerradura hasta que alguien se conecte vía Bluetooth desde la app móvil y sincronice.",
    loading: "Cargando historial…",
    empty: "No hay passcodes registrados para esta cerradura.",
    colAlias: "Alias",
    colPasscode: "Passcode",
    colValidity: "Vigencia",
    colStatus: "Estado",
    createdAt: "Creado: {date}",
    fromLabel: "Desde:",
    toLabel: "Hasta:",
    revokedTitle: "Ya revocado",
    revokeTitle: "Eliminar / Revocar Passcode",
    close: "Cerrar",
  },
  passcodeModal: {
    title: "Crear Passcode Temporal",
    nameLabel: "Nombre / Etiqueta",
    namePlaceholder: "Ej: Limpieza / Huésped / Técnico",
    nameHint: "Este nombre te ayudará a identificar el código.",
    validFrom: "Válido desde",
    validTo: "Válido hasta",
    importantLabel: "Importante:",
    importantText:
      "El código será generado automáticamente por TTLock y estará disponible solo durante el periodo indicado. El huésped puede ingresar este código directamente en el teclado de la cerradura (funciona sin internet).",
    noGatewayLabel: "Sin Gateway:",
    noGatewayText:
      "Esta cerradura no tiene gateway conectado. Los códigos generados funcionarán perfectamente en el teclado físico, pero no podrás revocarlos remotamente desde este panel. Para revocar, tendrás que hacerlo desde la app TTLock conectándote vía Bluetooth.",
    cancel: "Cancelar",
    creating: "Creando...",
    create: "Crear Passcode",
  },
  states: {
    active: "Activo",
    upcoming: "Próximo",
    expired: "Expirado",
    revoked: "Revocado",
    noDate: "Sin fecha",
  },
  confirm: {
    revoke:
      '¿Seguro que deseas revocar/eliminar el Passcode "{alias}"?\n\nNota: Si la cerradura no tiene gateway, la revocación puede ser solo parcial.',
  },
  toast: {
    noLocksFound: "No se encontraron cerraduras en TTLock.",
    loadStatusError: "No se pudo cargar locks-status",
    loadStatusErrorGeneric: "Error cargando locks-status",
    credentialsRequired: "Debes ingresar username y password o tener credenciales guardadas.",
    connectionOk:
      "Conexión exitosa. {count} dispositivo encontrado. | Conexión exitosa. {count} dispositivos encontrados.",
    testError: "Error al probar la conexión",
    credentialsSaved: "Credenciales guardadas correctamente",
    saveCredentialsError: "Error al guardar credenciales",
    saveCredentialsErrorDetail: "Error al guardar credenciales: {msg}",
    selectAtLeastOne: "Debes seleccionar al menos un dispositivo para esta propiedad.",
    devicesSaved: "Dispositivos guardados para esta propiedad",
    devicesSaveError: "No se pudo guardar los dispositivos",
    saveErrorDetail: "Error al guardar: {msg}",
    unitRequired: "Selecciona la unidad para las cerraduras asignadas como 'Puerta de apartamento'.",
    bindingsSaved: "Asignación guardada correctamente",
    bindingsSaveError: "No se pudo guardar la asignación",
    bindingsSaveErrorDetail: "Error al guardar asignación: {msg}",
    assignFirst: "Asigna primero la cerradura (puerta principal o unidad) y guarda para habilitar control.",
    passcodeNameRequired: "Debes indicar un nombre/etiqueta para el Passcode.",
    passcodeDatesRequired: "Debes indicar válido desde y válido hasta.",
    passcodeCreated: "Passcode creado: {code}",
    passcodeCreateError: "No se pudo crear el Passcode",
    passcodeCreateErrorGeneric: "Error creando Passcode",
    lockLocked: "Cerradura bloqueada",
    lockLockError: "No se pudo bloquear",
    lockLockErrorGeneric: "Error al bloquear",
    lockUnlocked: "Cerradura desbloqueada",
    lockUnlockError: "No se pudo desbloquear",
    lockUnlockErrorGeneric: "Error al desbloquear",
    revokeNoProviderId: "Este Passcode no tiene provider_passcode_id. No se puede revocar en TTLock.",
    revokedOk: "Passcode revocado completamente",
    revokeError: "No se pudo revocar",
    revokeErrorGeneric: "Error revocando Passcode",
    historyLoadError: "No se pudo cargar el historial",
    historyLoadErrorGeneric: "Error cargando historial",
  },
};
